import './ServicesSection.css';
import { Link } from 'react-router-dom';

const services = [
    {
        title: 'Maçonnerie',
        image: '/images/OmTravaux/Macon1.jpg',
        intro:
            'Avant de commencer votre projet de rénovation maçonnerie à 94, Île-de-France, il est essentiel de prendre en compte plusieurs facteurs.',
        link: '/services/maconnerie',
    },
    {
        title: 'Placo / Plâtre',
        image: '/images/OmTravaux/Sdb1.jpg',
        intro:
            'Avant de lancer vos travaux de placo ou faux plafond, un bon diagnostic de vos surfaces est indispensable.',
        link: '/services/placo',
    },
    {
        title: 'Isolation',
        image: '/images/OmTravaux/Iso5.jpg',
        intro:
            'L’isolation est clé dans tout projet de rénovation : confort thermique, économie d’énergie et acoustique.',
        link: '/services/isolation',
    },
    {
        title: 'Carrelage',
        image: '/images/OmTravaux/Cuisine2.jpg',
        intro:
            'Choisir le bon carrelage et un calepinage adapté permet de transformer visuellement vos pièces.',
        link: '/services/carrelage',
    },
    {
        title: 'Menuiserie',
        image: '/images/OmTravaux/Sdb2.jpg',
        intro:
            'Un bon agencement bois peut donner du cachet et optimiser vos espaces et vos envies avec style.',
        link: '/services/menuiserie',
    },
];

export default function ServicesSection() {
    return (
        <section className="services-section" id="services">
            <div className="services-container">
                <div className="services-heading">
                    <p className="services-badge">Nos services</p>

                    <h2 className="services-title">
                        Des prestations complètes pour une rénovation
                        <span> intérieure soignée et durable</span>
                    </h2>

                    <p className="services-subtext">
                        Nos services couvrent tous les aspects de la{' '}
                        <strong>rénovation d’intérieur en Île-de-France</strong>. Qu’il
                        s’agisse d’une rénovation complète d’appartement ou d’une
                        intervention ciblée sur une pièce, chaque projet bénéficie d’une
                        approche sérieuse, personnalisée et pensée pour durer.
                    </p>
                </div>

                <div className="services-grid">
                    {services.map((service, index) => (
                        <article className="service-card" key={index}>
                            <Link to={service.link} className="service-image-link">
                                <div className="service-img-wrapper">
                                    <img
                                        src={service.image}
                                        alt={service.title}
                                        className="service-img"
                                    />
                                    <div className="service-img-overlay">
                                        <span>Voir le service</span>
                                    </div>
                                </div>
                            </Link>

                            <div className="service-card-content">
                                <h3>{service.title}</h3>
                                <p className="service-intro">{service.intro}</p>

                                <Link to={service.link} className="service-link">
                                    Découvrir le service
                                    <span className="service-link-arrow">→</span>
                                </Link>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}